// Primero: zod sin compilación JIT. Su sondeo `new Function("")` choca con la CSP (`script-src 'self'`) y
// llena la consola de violaciones en cada carga.
import '@/lib/zodConfig';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/index.css';
import { App } from '@/app/App';

const root = document.getElementById('root');
if (!root) throw new Error('Falta #root en index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
